// extracted by mini-css-extract-plugin
export var Ribbon = "rich-text-content-module--Ribbon--2835d";
export var RibbonTopRight = "rich-text-content-module--RibbonTopRight--815ad";
export var RichTextDefault = "rich-text-content-module--RichTextDefault--bb871";
export var anchor = "rich-text-content-module--anchor--94764";
export var downloadContainer = "rich-text-content-module--download-container--a7eb0";
export var formOuterWrapper = "rich-text-content-module--form-outer-wrapper--5f920";
export var formSubmit = "rich-text-content-module--form-submit--d5b59";
export var formWrapper = "rich-text-content-module--form-wrapper--60284";
export var inlineDownloadTitle = "rich-text-content-module--inline-download-title--7f703";
export var inlineImage = "rich-text-content-module--inline-image--c1ceb";
export var listItem = "rich-text-content-module--list-item--9f05f";